"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _imageTile = _interopRequireDefault(require("./common/image-tile"));
var _rtbTile = _interopRequireDefault(require("./common/rtb-tile"));
/* eslint-disable max-len */

const Container = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Container",
  class: "pl-cy2ft5t"
});

/**
 * SearchComponents Component.
 *
 * @param {Object} props React props
 * @returns {React.ReactElement} SearchComponents Component
 * @public
 */

function SearchComponents({
  imageTile,
  rtbTile
}) {
  return /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(_imageTile.default, imageTile), /*#__PURE__*/_react.default.createElement(_rtbTile.default, rtbTile));
}
var _default = exports.default = SearchComponents;
SearchComponents.propTypes = {
  imageTile: _imageTile.default.propTypes,
  rtbTile: _rtbTile.default.propTypes
};
SearchComponents.defaultProps = {
  imageTile: {
    image: {
      url: 'https://img1.wsimg.com/cdnassets/transform/7e007e97-f49e-48e5-9a7b-d9d581428491/hp-inl-motion-marquee-poster-dsk',
      altText: 'alt'
    },
    tagLabel: 'Tag Label',
    labelDesign: 'default',
    title: '5 key social media trends',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    tutorialLength: '5 min',
    ctas: [{
      text: 'Start Tutorial',
      href: '#',
      design: 'primary',
      size: 'small',
      templateName: 'Button Component',
      width: 'full'
    }]
  },
  rtbTile: {
    tagLabel: 'Help Articles',
    heading: 'Top Help Results',
    rtbList: [{
      title: 'RTB Title 1',
      description: 'RTB Description 1',
      url: 'https://www.godaddy.com'
    }, {
      title: 'RTB Title 2',
      description: 'RTB Description 2',
      url: 'https://www.godaddy.com'
    }, {
      title: 'RTB Title 3',
      description: 'RTB Description 3',
      url: 'https://www.godaddy.com'
    }],
    ctas: [{
      text: 'View More Articles',
      href: '#',
      design: 'secondary',
      size: 'small',
      templateName: 'Button Component',
      width: 'full'
    }]
  }
};